module.exports = __webpack_public_path__ + "static/media/_DSC1590.d097aa53.jpg";